<div class="container-box">
  <app-table-header tableTitle="Gestione Utenti" (btnUpdateClick)="refreshUsers()">
    <app-button-new-user action-button></app-button-new-user>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="usersTable"
      class="table-content"
      [settings]="settings"
      [source]="sourceUsersTable"
    ></ng2-smart-table>
  </div>
</div>
